import React, { useState, useEffect } from "react";
import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import axios from "axios";

const Tezos = new TezosToolkit("https://mainnet.smartpy.io");
const wallet = new BeaconWallet({ name: "Temple Wallet Settings" });
Tezos.setWalletProvider(wallet);

const SettingsPage = () => {
  const [walletAddress, setWalletAddress] = useState("");
  const [settings, setSettings] = useState({
    showMatureContent: false,
    showFlashingHazards: true,
    notifications: {},
    advancedMode: false,
    hangingListings: false,
    ignoredTokens: [],
    ignoredWallets: [],
    minimumOffer: 0,
    country: "",
  });

  useEffect(() => {
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress) {
      setWalletAddress(storedAddress);
      fetchWalletSettings(storedAddress);
    }
  }, []);

  // Fetch settings from API
  const fetchWalletSettings = async (walletAddress) => {
    try {
      const response = await axios.get(
        `https://api.example.com/user-settings/${walletAddress}`
      );
      if (response.data) {
        setSettings(response.data);
      }
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };

  // Update settings in API
  const updateWalletSettings = async (updatedSettings) => {
    try {
      await axios.put(
        `https://api.example.com/user-settings/${walletAddress}`,
        updatedSettings
      );
      console.log("Settings updated successfully!");
    } catch (err) {
      console.error("Error updating settings:", err);
    }
  };

  // Handle setting change and update API
  const handleSettingChange = (key, value) => {
    const updatedSettings = { ...settings, [key]: value };
    setSettings(updatedSettings);
    updateWalletSettings(updatedSettings); // Call API to save changes
  };

  return (
    <div className="min-h-screen p-28 bg-gray-100">
      <div className="w-full mx-auto bg-white shadow-lg p-6 rounded-lg">
        <h2 className="text-2xl font-bold mb-6">Settings</h2>
        <p className="text-sm text-gray-500">
          Wallet: {walletAddress || "Not Connected"}
        </p>

        {/* Content Settings */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2">Content</h3>
          <div className="flex justify-between p-2 border-b">
            <span>Show Mature Content</span>
            <input
              type="checkbox"
              checked={settings.showMatureContent}
              onChange={() =>
                handleSettingChange(
                  "showMatureContent",
                  !settings.showMatureContent
                )
              }
            />
          </div>
          <div className="flex justify-between p-2 border-b">
            <span>Show Flashing Hazards</span>
            <input
              type="checkbox"
              checked={settings.showFlashingHazards}
              onChange={() =>
                handleSettingChange(
                  "showFlashingHazards",
                  !settings.showFlashingHazards
                )
              }
            />
          </div>
        </div>

        {/* Country Selection */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2">Country</h3>
          <select
            value={settings.country}
            onChange={(e) => handleSettingChange("country", e.target.value)}
            className="border p-2 rounded"
          >
            <option value="">Select a country</option>
            <option value="US">United States</option>
            <option value="IN">India</option>
            <option value="UK">United Kingdom</option>
          </select>
        </div>

        {/* Notifications */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2">Notifications</h3>
          {Object.keys(settings.notifications).map((key) => (
            <div key={key} className="flex justify-between p-2 border-b">
              <span>{key.replace(/([A-Z])/g, " $1").trim()}</span>
              <input
                type="checkbox"
                checked={settings.notifications[key]}
                onChange={() =>
                  handleSettingChange("notifications", {
                    ...settings.notifications,
                    [key]: !settings.notifications[key],
                  })
                }
              />
            </div>
          ))}
        </div>

        {/* Minimum Offer */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2">Minimum Offer</h3>
          <input
            type="number"
            value={settings.minimumOffer}
            onChange={(e) =>
              handleSettingChange("minimumOffer", e.target.value)
            }
            className="border p-2 rounded w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
